import { SetStateAction, useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { SensorSlotData } from "../../../../types/types";
import { DateTime } from "luxon";
import BaseChart from "../../../../ui/Charts/baseChart";
import Spinner from "../../../../ui/Spinner/Spinner";

type Props = {
  sensor: SensorSlotData,
  selectedDate: {
    from: Date,
    to: Date,
  }
};

const DeviceNetworkSensorData = ({ sensor, selectedDate }: Props) => {
  const [sensorData, setSensorData] = useState<any>()
  const [loading, setLoading] = useState(true)
  const [dates, setDates] = useState({from: selectedDate?.from?.toISOString(), to: selectedDate?.to?.toISOString()})

  const [{ response: itemNetworkResponse, isLoading: itemNetworkIsLoading, error: itemNetworkError }, doFetchNetwork] =
    useFetch(`/devices/sensors/${sensor.id}/receiving_delay?from=${dates.from}&to=${dates.to}`);

  useEffect(() => {
    if(!dates.to || !dates.from) { return }
    doFetchNetwork()
    setLoading(true)
  }, [sensor.id, dates])

  useEffect(() => {
    if(itemNetworkIsLoading) { return }

    setSensorData(itemNetworkResponse?.data.attributes.data)
    setLoading(false)
  }, [itemNetworkResponse])


  return (
    <div className="flex flex-col p-3 space-y-4 rounded" style={{backgroundColor: "rgba(0, 143, 245, 0.05)"}}>
      <BaseChart 
        data={sensorData} 
        type="network" 
        title="Сетевые задержки"
        selectedDate={selectedDate} 
        dates={dates} 
        onChangeDates={setDates}
        loading={loading}
      />
    </div>
  );
};

export default DeviceNetworkSensorData;
